import PartnerDividends from 'modules/partners/components/PartnerDividends';
import DetailsProfileSection from 'modules/_shared/components/Sections/DetailsProfileSection';
import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';
import { checkIsPartnerCoOwner } from 'modules/partners/utils/checkIsPartnerCoOwner';

import { useTranslate } from 'hooks/useTranslate';
import { usePartnerSociety } from './hooks/usePartnerSociety';
import PartnerSocietyMetrics from './components/PartnerSocietyMetrics';
import PartnerSocietyPercentage from './components/PartnerSocietyPercentage';
import PartnerShares from '../PartnerShares';
import PartnerSocietyTableWrapper from './components/PartnerSocietyTableWrapper';
import PartnerSocietySharesOffers from './components/PartnerSocietySharesOffers';
import { PartnerDividendsProvider } from '../PartnerDividends/context/PartnerDividendsContext';
import { PartnerSharesProvider } from '../PartnerShares/context/PartnerSharesContext';

function PartnerSociety({ partner, society, inversion, badges, isLoading }) {
  const { t } = useTranslate();
  const { isAdmin, isReadOnly } = useGetPartnersSectionPermissions().data;
  const isCoOwner = checkIsPartnerCoOwner(partner);

  const {
    data: {
      fullName,
      hasSellSharesEnabled,
      hasBuySharesEnabled,
      hasEquityMarketEnabled,
      isReadOnlyUser,
      decimalScale,
      NDpercent,
      FDpercent,
      PFDPercent,
    },
    actions: {
      handleOpenBuyShares,
      handleOpenSellShares,
      handleOpenEquityMarket,
    },
  } = usePartnerSociety({
    partner,
    society,
    isReadOnly,
  });

  return (
    <div className="card-inner-group">
      <DetailsProfileSection
        name={fullName}
        image={society.additional.logo}
        badges={badges}
        description=""
      />

      <PartnerSocietySharesOffers
        isReadOnly={isReadOnly}
        isReadOnlyUser={isReadOnlyUser}
        hasBuySharesEnabled={hasBuySharesEnabled}
        hasSellSharesEnabled={hasSellSharesEnabled}
        hasEquityMarketEnabled={hasEquityMarketEnabled}
        handleOpenBuyShares={handleOpenBuyShares}
        handleOpenSellShares={handleOpenSellShares}
        handleOpenEquityMarket={handleOpenEquityMarket}
      />

      <PartnerSocietyMetrics
        partner={partner}
        society={society}
        inversion={inversion}
        fullName={fullName}
        decimalScale={decimalScale}
        NDpercent={NDpercent}
        isAdmin={isAdmin}
        isLoading={isLoading}
      />

      <PartnerSocietyPercentage
        decimalScale={decimalScale}
        NDpercent={NDpercent}
        FDpercent={FDpercent}
        PFDPercent={PFDPercent}
        society={society}
        isAdmin={isAdmin}
      />

      <div className="py-4">
        <PartnerSharesProvider partner={partner}>
          <PartnerShares />
        </PartnerSharesProvider>
      </div>

      {isCoOwner && (
        <div className="py-4">
          <PartnerSharesProvider partner={partner} isCoOwner>
            <PartnerShares />
          </PartnerSharesProvider>
        </div>
      )}

      <PartnerSocietyTableWrapper title={t('DividendsDistribution')}>
        <PartnerDividendsProvider
          partner={partner}
          showTitle={false}
          isSummaryView
        >
          <PartnerDividends />
        </PartnerDividendsProvider>
      </PartnerSocietyTableWrapper>
    </div>
  );
}

export default PartnerSociety;
